import inRange from 'lodash/inRange';

export const color = (value) => (
  (inRange(value, 45, 55) && '#8cf08c') ||
  ((inRange(value, 30, 45) || inRange(value, 55, 70)) && '#f7d89c') ||
  ((inRange(value, 15, 30) || inRange(value, 70, 85)) && '#f9cfcf') ||
  '#fb5b5b'
);
